import { useEffect } from "react";
import "../../src/App.css";

const MagicCursor = () => {
    useEffect(() => {
        if (window.magicMouseInitialized) return;
        const existingCursor = document.getElementById("magicMouseCursor");
        const existingPointer = document.getElementById("magicPointer");
        if (existingCursor) existingCursor.remove();
        if (existingPointer) existingPointer.remove();

        if (!document.querySelector('script[src*="magicmouse"]')) {
            const script = document.createElement("script");
            script.src =
                "https://res.cloudinary.com/veseylab/raw/upload/v1684982764/magicmouse-2.0.0.cdn.min.js";
            script.async = true;

            script.onload = () => {
                const options = {
                    cursorOuter: "circle-basic",
                    hoverEffect: "circle-move",
                    hoverItemMove: false,
                    defaultCursor: false,
                    outerWidth: 50,
                    outerHeight: 50,
                };

                if (window.magicMouse) {
                    window.magicMouse(options);
                    window.magicMouseInitialized = true;
                    console.log("✅ MagicMouse initialized once");
                }
            };

            document.body.appendChild(script);
        }
    }, []);

    return null;
};

export default MagicCursor;
